<template>
  <router-view/>
</template>

<style>
/* Vuetify v-btn 默认 text-transform: uppercase，会强制大写按钮里的英文字母。
   与 .v-btn 同优先级时依赖加载顺序，时灵时不灵，用更高优先级钉死 */
.v-btn .v-btn__content,
.v-btn {
  text-transform: none !important;
  letter-spacing: normal;
}
</style>
